var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedactionListEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 129,
    viewBox: "0 0 166 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_4551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8 19.5802C16.42 19.5802 17.74 18.2602 17.74 16.6402C17.74 15.0202 16.42 13.7002 14.8 13.7002C13.18 13.7002 11.86 15.0202 11.86 16.6402C11.86 18.2602 13.18 19.5802 14.8 19.5802Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.91 19.5802C30.53 19.5802 31.85 18.2602 31.85 16.6402C31.85 15.0202 30.53 13.7002 28.91 13.7002C27.29 13.7002 25.97 15.0202 25.97 16.6402C25.97 18.2602 27.29 19.5802 28.91 19.5802Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.94 19.5802C44.56 19.5802 45.88 18.2602 45.88 16.6402C45.88 15.0202 44.56 13.7002 42.94 13.7002C41.32 13.7002 40 15.0202 40 16.6402C40 18.2602 41.32 19.5802 42.94 19.5802Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.46 126.16C6.34 126.16 3 122.82 3 118.7V10.2998C3 6.17984 6.34 2.83984 10.46 2.83984H155.53C159.65 2.83984 162.99 6.17984 162.99 10.2998V117.01C162.99 117.01 163.28 126.15 154.2 126.15H29.24C24.69 126.15 21 122.46 21 117.91V33.4998H145V100.25C145 105.59 140.67 109.91 135.34 109.91H34.2",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59 16.6396H145.7",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.46 53.8496H34.46V93.8496H74.46V53.8496Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46 80.0396V93.8496H131.46V53.8496H91.46V63.0696",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 73.5798H90.95C91.22 73.5798 91.43 73.3598 91.43 73.0998V69.3798C91.43 68.9498 91.95 68.7298 92.26 69.0398L97.02 73.7998C97.21 73.9898 97.21 74.2898 97.02 74.4798L91.46 80.0398",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_4551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 128.32,
    fill: "white",
    transform: "translate(0.5 0.339844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedactionListEmptyState);
export default __webpack_public_path__ + "static/media/redaction-list-empty-state.729ed3045862dd97b7c77cfbf694582a.svg";
export { ForwardRef as ReactComponent };